import { atomFamily, selectorFamily } from "recoil";
import find from "lodash/find";
import { getGreenlineGameEndStats } from "api/ClinicApi";

const loadGameEndStats = selectorFamily({
    key: "LoadGameEndStats",
    get: ({ clinicId, gameId }) => async () => {
        const response = await getGreenlineGameEndStats(clinicId, gameId);
        return response.body;
    },
});

export const gameEndStatsState = atomFamily({
    key: "GameEndStatsState",
    default: loadGameEndStats,
});

export const getClinicEndGameStats = selectorFamily({
    key: "GetClinicEndGameStats",
    get: ({ clinicId, gameId }) => ({ get }) => {
        const stats = get(gameEndStatsState({ clinicId, gameId }));
        return find(stats.gameClinicPrizesDto, { clinicId: clinicId });
    }
})